import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Losing three hours every Sunday night programming the week', 'Staring at a blank page trying to invent "one more" workout', 'A downloads folder full of workout packs you never open', 'Running the same five circuits because there was no time to plan new ones', 'Thirty people show up and your plan was built for twelve', 'It rains, the park is closed, and the session falls apart', 'A new client with a bad knee and no regression ready', 'Losing your voice by Thursday and the room by minute 40'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-136" data-mp="1bqvymd1j8mun">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-137" data-mp="17oiwdylzv72m">
        <div className="text-center" data-id="element-138" data-mp="17qc3ff0irtb5">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-139" data-mp="364dq2b5263uy">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-140" data-mp="323levccmlow1">
            If you run bootcamps, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-141" data-mp="3l5tq4nnukear">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-142" data-mp="37armk76h3114">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-143" data-mp="2u6xurnmfdcz">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-144" data-mp="7v4hl8oa4fgl">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-145" data-mp="3u8mi6t4usu1n" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl sm:text-3xl text-gold leading-tight" data-id="element-146" data-mp="lrrmpyqdybxl">
          How many more Sunday nights do you want to give away?
        </p>
      </div>
    </section>;
}